const setRegexInput = (regex, className, functionExtra = () => { }) => {
  const inputElements = document.querySelectorAll(className)
  inputElements.forEach(input => {
    setInputFilter(input, value => {
      functionExtra(input)
      return regex.test(value)
    })
  })
}

const phoneRegex = /^[0-9\-]*$/
setRegexInput(phoneRegex, '.js-only-phone', (input) => {
  input.value = input.value
    .replace(/\D+/g, '')
    .replace(/(\d{3})(\d)/, '$1-$2')
    .replace(/(\d{3})(\d)/, '$1-$2')
})

const numberRegex = /^[0-9]*$/
setRegexInput(numberRegex, '.js-only-numbers')

const letterRegex = /^[a-zA-ZáéíóúÁÉÍÓÚ\'´ñÑäëïöüÄËÏÖÜ \-]*$/
setRegexInput(letterRegex, '.js-only-letters')

const alphaNumericRegex = /^[0-9a-zA-Z]*$/
setRegexInput(alphaNumericRegex, '.js-only-alpha-numeric')

const dateRegex = /^[0-9\/]*$/
setRegexInput(dateRegex, '.js-only-date', (input) => {
  input.value = input.value
    .replace(/\D+/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
})

const inputFile = document.querySelectorAll('#input-file')
inputFile.forEach(input => {
  input.addEventListener('change', (e) => {
    const fichero = e.target.files[0]
    const extension = fichero.name.substring(fichero.name.lastIndexOf(".") + 1);
    const labelForm = document.querySelector('.form-label-error.js-form-error')

    if (labelForm) labelForm.remove()

    if (!(fichero && ['pdf', 'doc', 'docx'].includes(extension) && fichero.size <= 5242880)) {
      const formElement = document.querySelector('.c-hero-form.js-form')
      const labelErrorForm = document.createElement('label')
      labelErrorForm.classList.add('form-label-error', 'js-form-error')
      labelErrorForm.textContent = 'Please, enter a valid file.'
      formElement.appendChild(labelErrorForm)
      e.target.value = ''
    }
  })
})

const inputForm = document.querySelectorAll('.c-hero-form__input')

inputForm.forEach(input => {
  input.value = ''
  const labelForm = input.parentNode.querySelector('.c-hero-form__label')
  input.addEventListener('focus', () => {
    input.classList.add('has-focus')
    labelForm.classList.add('is-floating')
  })
  input.addEventListener('blur', () => {
    input.classList.remove('has-focus')
    if(input.value === '') labelForm.classList.remove('is-floating')
  })
})
